import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import SimpleCard from './SimpleCard';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  error: {
    color: 'red',
  },
});


class RadioButtonsGroup extends React.Component {
  constructor(props){
    super(props);
    if (props.participants){
      this.state = {
        staff: props.participants.staff,
        players: props.participants.players,
      };
    }else{
      this.state = {
        staff: 1,
        players: 15,
      };
    }
  }
  handleChange = (key) => (event) => {
    let newValue = event.target.value;
    let outValue = newValue;
    if (key === 'players'){
      if (newValue > 15) outValue = 15;
      if (newValue < 7) outValue = 7;
    }
    if (key === 'staff'){
      if (newValue > 2) outValue = 2;
      if (newValue < 1) outValue = 1;
    }

    this.setState({ [key]: Number(newValue) });
    this.props.choiceHandler( { ...this.state, [key]: Number(outValue) } );
  };

  render() {
    const { classes } = this.props;

    return (
        <div>
      <div className={classes.root}>
      <TextField
          required
          id="staff"
          label="Cuerpo Técnico"
          type="number"
          value={this.state.staff}
          className={classes.textField}
          onChange={this.handleChange('staff')}
          margin="normal"
        />      
      <TextField
        required
        id="players"
        label="Jugadores"
        type="number"
        min="7"
        max="15"
        value={this.state.players}
        className={classes.textField}
        onChange={this.handleChange('players')}
        margin="normal"
      />
      { (this.state.players > 15 || this.state.players < 7 || this.state.staff < 1 || this.state.staff > 2) &&
      <Typography className={classes.error} type='body1'>
        El número de jugadores puede variar entre 7 y 15 y como máximo puede haber 2 personas del cuerpo técnico.
      </Typography>
      }
      </div>
        <SimpleCard headline='Número de participantes' content={<Typography component="p">El siguiente paso es saber cuantas personas vienen.</Typography>}/>
      </div>
    );
  }
}

RadioButtonsGroup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RadioButtonsGroup);


// WEBPACK FOOTER //
// ./src/components/InputParticipants.jsx